import styled from 'styled-components';

export const SearchInput = styled.input`
  width: 100%;
  padding: 12px 15px;
  margin-bottom: 30px;
  border: 1px solid ${({ theme }) => theme.cardBorder};
  border-radius: 8px;
  font-size: 16px;
  background-color: ${({ theme }) => theme.inputBg};
  color: ${({ theme }) => theme.heading};
  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.primary};
  }
`;

export const ClientGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
`;